import type { BodyProps, PopoverContentProps } from '@sunwebgroup/uds-ui/popover'
import { Popover as CssModulesPopover } from '@sunwebgroup/uds-ui/popover'
import { styled } from 'styled-components'

export const Root = Object.assign(
  styled(CssModulesPopover.Root)``,
  { displayName: 'Popover.Root' },
)

export const Trigger = Object.assign(
  styled(CssModulesPopover.Trigger)``,
  { displayName: 'Popover.Trigger' },
)

export const Content = Object.assign(
  styled(CssModulesPopover.Content)<PopoverContentProps>``,
  { displayName: 'Popover.Content' },
)

export const Body = Object.assign(
  styled(CssModulesPopover.Body)<BodyProps>``,
  { displayName: 'Popover.Body' },
)
